import { z } from "zod";
const ChainDataSchema = z.object({
  packageId: z.string(),
  chainId: z.string()
});
export {
  ChainDataSchema
};
//# sourceMappingURL=chainData.js.map
